export default "__VITE_ASSET__a7e89fce__"